var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0003 1C11.9301 1 12.395 1 12.7765 1.10222C13.8117 1.37962 14.6204 2.18827 14.8978 3.22354C15 3.60504 15 4.07003 15 5V5C15 5.02722 15 5.05469 15 5.0824C15 7.18972 15 8.24337 14.4944 9.00004C14.2755 9.32762 13.9943 9.60887 13.6667 9.82774C12.91 10.3333 11.8567 10.3333 9.75 10.3333V10.3333C8.35 10.3333 6.2607 13 5.9 13C5.44048 13 5.66808 10.3333 5.2 10.3333V10.3333C4.08323 10.3333 3.52485 10.3333 3.07295 10.1865C2.15964 9.88975 1.44359 9.1737 1.14683 8.26039C1 7.80849 1 7.24997 1 6.13294C1 5.73069 1 5.34483 1 5V5C1 4.07003 1 3.60504 1.10222 3.22354C1.37963 2.18827 2.18827 1.37962 3.22354 1.10222C3.60504 1 4.06992 1 4.99967 1C6.00642 1 7.0658 1 8 1C8.9342 1 9.99358 1 11.0003 1Z",
    stroke: "#584D41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.ecab8b766b62345fa3ae3cf33bdc47f7.svg";
export { ForwardRef as ReactComponent };